<button
  class="fz-filters__button-control fz-filters__button-control__icon"
  mat-icon-button
  color="primary"
  [matBadge]="activeFilterCount()"
  [matBadgeHidden]="activeFilterCount() === 0"
  (click)="toggleFilterPanel($event)"
>
  <mat-icon>filter_alt</mat-icon>
</button>

<button
  class="fz-filters__button-control fz-filters__button-control__large"
  mat-stroked-button
  (click)="toggleFilterPanel($event)"
>
  <mat-icon>filter_alt</mat-icon>
  Filters
  @if (activeFilterCount() > 0) {
    ({{ activeFilterCount() }})
  }
</button>
